import React from "react";

import { CheckForm, Group, Section } from "@samskip/frontend-components";
import { UseFormRegister } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { ShippingTypeBookingTemplates } from "@assets/constants";
import { BookingTemplateFormTypes } from "@assets/formTypes";
import { CommonTypes } from "@assets/types";

type ShipmentSection = {
  register: UseFormRegister<BookingTemplateFormTypes.CargoForm>;
  onShipmentTypeChange: CommonTypes.CallbackFunction;
};

const ShipmentSection = ({
  register,
  onShipmentTypeChange,
}: ShipmentSection) => {
  const { t } = useTranslation();

  return (
    <Section title={t("LABEL_SHIPMENT")}>
      <Group
        onChange={onShipmentTypeChange}
        title={t("LABEL_SHIPMENT_TYPE")}
        vertical
      >
        <CheckForm
          id="l_l"
          label={`${t("LABEL_LL")} (${t("INFO_LL")})`}
          type="radio"
          value={ShippingTypeBookingTemplates.LL}
          {...register("ShippingType")}
        />
        <CheckForm
          id="f_f"
          label={`${t("LABEL_FF")} (${t("INFO_FF")})`}
          type="radio"
          value={ShippingTypeBookingTemplates.FF}
          {...register("ShippingType")}
        />
        <CheckForm
          id="f_l"
          label={`${t("LABEL_FL")} (${t("INFO_FL")})`}
          type="radio"
          value={ShippingTypeBookingTemplates.FL}
          {...register("ShippingType")}
        />
        <CheckForm
          id="l_f"
          label={`${t("LABEL_LF")} (${t("INFO_LF")})`}
          type="radio"
          value={ShippingTypeBookingTemplates.LF}
          {...register("ShippingType")}
        />
      </Group>
    </Section>
  );
};

export default ShipmentSection;
